export default __webpack_public_path__ + "images/TiemposHeadline-Regular.font.b17bbb323a4667d1fab873d5100d637f.svg";